/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Retiro de helper flotante global
* ---------------------------------------------------------------------------------------
*/

import logo from '../src/img/sizesoftx-logo1.svg';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { esES } from "@mui/x-date-pickers/locales";
import es from "date-fns/locale/es";
import { AllSystemProvider } from "./context/System/AllSystemProvider";
import { AllVentasProvider } from "./context/Ventas/AllVentasProvider";
import { AllCatalogosProvider } from "./context/Catalogos/AllCatalogosProvider";
import { AllInventariosProvider } from "./context/Inventarios/AllInventariosProvider";
import { AllAdministracionProvider } from "./context/Administracion/AllAdministracionProvider";
import { AllParametrosProvider } from "./context/Parametros/AllParametrosProvider";
import { AllToolsProvider } from './context/Tools/AllToolsProvider';
import { AllIAProvider } from './context/IA/AllIAProvider';
import { AllConteosEscaneoProvider } from './context/ConteosEscaneo/AllConteosEscaneoProvider';
import SizeSoftXPage  from "./components/leyout/SizeSoftXPage";
import SizeSoftXHelpPanel from "./components/helpconfig/SizeSoftXHelpPanel";
import { TenantSyncProvider } from "./context/TenantSync/TenantSyncContext";

function App() {
  return (
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          localeText={
            esES.components.MuiLocalizationProvider.defaultProps.localeText
          }
          adapterLocale="es"
        >
          <AllSystemProvider>
            <TenantSyncProvider>
            <AllInventariosProvider>
              <AllAdministracionProvider>
                <AllToolsProvider>
                  <AllParametrosProvider>
                    <AllCatalogosProvider>
                      <AllIAProvider>
                        <AllVentasProvider>
                          <AllConteosEscaneoProvider>
                          <SizeSoftXPage />
                          <SizeSoftXHelpPanel />
                          </AllConteosEscaneoProvider>
                        </AllVentasProvider>
                      </AllIAProvider>
                    </AllCatalogosProvider>
                  </AllParametrosProvider>
                </AllToolsProvider>
              </AllAdministracionProvider>
            </AllInventariosProvider>
            </TenantSyncProvider>
          </AllSystemProvider>
        </LocalizationProvider>
      </BrowserRouter>
    );
}

export default App;

